import { lazy, Suspense } from 'react'

import { FvButton } from '@fv/client-components'

import { Loading } from '@/components/Loading'
import { ShipperSlider } from '@/components/ShipperSlider'
import { ShipperTooltip } from '@/components/ShipperTooltip'

import { useAccountFeatures } from '../auth'
import { useChatPanel } from './ChatPanelProvider'

const ChatApp = lazy(() => import('./ChatApp'))

export const ChatLink = () => {
  const { closePanel, isPanelOpen, togglePanel } = useChatPanel()
  const { chatBot } = useAccountFeatures()
  if (!chatBot) return null

  return (
    <>
      <ShipperTooltip label="Chat with Pallet Jack, your Freightview AI assistant">
        <FvButton
          icon="pallet-jack"
          onClick={togglePanel}
          className="ml-0"
          transform="up-1"
        />
      </ShipperTooltip>

      <ShipperSlider
        isOpen={isPanelOpen}
        onClose={closePanel}
        width="58rem"
        flush
        overflowHidden
        className="bg-fv-blue-25"
      >
        <Suspense fallback={<Loading />}>
          <ChatApp />
        </Suspense>
      </ShipperSlider>
    </>
  )
}
